import React, { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import PropTypes from "prop-types";
import "./DefaultTextInput.css";
const DefaultTextInput = ({
  type="text",
  title,
  editableText,
  placeholder,
  value,
  onChangeValue,
  onEditClick=(editable)=>{},
}) => {
  const [editable, setEditable] = useState(false);
  return (
    <div className="inputDefaultWrapper">
      <div>
        <h6>{title}</h6>
        {/* <p>{email}</p> */}
        <input
          type={type}
          className="inputDefault"
          placeholder={placeholder}
          disabled={!editable}
          onChange={onChangeValue}
          value={value}
        />
        {editableText && (
          <div className="editIconInput" onClick={() => {
            editable?setEditable(false):setEditable(true);
            onEditClick(!editable);
          }}>
            {!editable?<EditIcon className="editIconSize" />:<DoneOutlineIcon className="editIconSize" />}
            
          </div>
        )}
      </div>
    </div>
  );
};

DefaultTextInput.propTypes = {
  title: PropTypes.string,
  placeholder: PropTypes.string,
  editableText: PropTypes.bool,
  onChangeValue: PropTypes.func,
  value: PropTypes.any,
};

DefaultTextInput.defaultProps = {
  title: "Title",
  placeholder: "PlaceHolder",
  editableText: true,
};
export default DefaultTextInput;
